import React from "react"
import { Link, graphql } from "gatsby"

import Layout from "../../components/layout"
import Header from "../../components/header"
import Content from "../../components/content"
import Footer from "../../components/footer"
import SEO from "../../components/seo"
import NewsAll from '../../components/news-all'
import Img from "gatsby-image"

const ArchivePage = () => {
    return (
        <Layout>
            <SEO title="Water Information" />
            <div className="main">
                <Header />
                <div className="main-content-container">
                <div className="main-content">
                    <div className="title-section">
                        <h1 className="title is-size-1">Water Information</h1>
                        </div>

                    <div class="image is-16by9"><iframe class="has-ratio" width="1545" height="731" src="https://www.youtube.com/embed/x37bsGScFCs" title="2024 AWBD Winter Preparedness PSA" 
                    frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowfullscreen></iframe></div>

                    <div className="title-section">
                        <h3 className="title is-size-2">Additional Resources</h3>
                        <Link to="/smart-meters" className="button is-primary is-large">Smart Meters</Link>&nbsp;&nbsp; <a 
                        href="/static/3fba9c3cef915f9828dc9055de55a26e/fbcmud023_ccr_2024_20250625_33b5ebed71.pdf" className="button is-primary is-large">Drinking Water Quality Report</a> 
                    </div>
                    
                </div>
                <Footer />
                </div>
            </div>
        </Layout>
    )
}

export default ArchivePage




